import dayjs from 'dayjs'

export const formatDate = (date, locale, format) => {
  const localizedFormat = require('dayjs/plugin/localizedFormat')
  require(`dayjs/locale/${locale}.js`)

  dayjs.extend(localizedFormat)

  return dayjs(date)
    .locale(locale)
    .format(format)
}
